import { Report56Container } from "../../../containers/SupportSystem/Reports/Report56Container";
export function Report56Page() {
    return (
        <Report56Container />
    );

}